import { usePlotGroupId } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { assertIsDefined } from '@/utils/assert';

import { useScenarioForm } from './useScenarioForm';

// TODO: MVP-CW rename to useIsLandPortionPlotGroup
export const useIsLandPortionProject = () => {
  const form = useScenarioForm();

  const plotGroupId = usePlotGroupId();

  const [landPortionId] = form.getValues(['landPortionId']);
  assertIsDefined(landPortionId, 'landPortionId');
  return landPortionId === plotGroupId;
};
